// Babel-safe emoji matcher (no Unicode property escapes)
const EMOJI_RE =
  /(?:\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDDFF]|[\u2600-\u27BF]|\uFE0F|\u200D)+/g;

const CODE_BLOCK_RE = /(<(?:pre|code)[^>]*>[\s\S]*?<\/(?:pre|code)>)/gi;

export function stripEmojis(text) {
  if (!text || typeof text !== 'string') return '';
  return text.replace(EMOJI_RE, '').replace(/\s+/g, ' ').trim();
}

export function wrapTablesInHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return html.replace(
    /<table(\s[^>]*)?>([\s\S]*?)<\/table>/gi,
    '<div class="blogPost__tableWrap"><table$1>$2</table></div>'
  );
}

// TAG_RE splits a chunk into alternating text nodes (even) and HTML tags (odd)
const TAG_RE = /(<[^>]+>)/g;

export function wrapEmojisInHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return html
    .split(CODE_BLOCK_RE)
    .map((chunk, index) => {
      if (index % 2 === 1) {
        // Inside a <pre> or <code> block — leave untouched
        return chunk;
      }
      // Split on HTML tags so we only replace emojis in text nodes,
      // not inside attribute values like alt="🎵"
      return chunk
        .split(TAG_RE)
        .map((subChunk, subIndex) => {
          if (subIndex % 2 === 1) {
            // This is an HTML tag — leave it untouched
            return subChunk;
          }
          return subChunk.replace(
            EMOJI_RE,
            match => '<span class="blogPost__emoji">' + match + '</span>'
          );
        })
        .join('');
    })
    .join('');
}
